import { BaseBloc } from '@core/utils/bloc';
import { resolve } from '@core/utils/ioc';
import { Blocs } from '@business/blocs';
import { LoadingState } from '@core/utils/repository/loading_state';
import { ArticleCategoryId } from '@business/entities/helpArticle';
import { forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';
import { R } from '@core/utils/r';

export class HelpArticlesPageBloc extends BaseBloc {
  private readonly helpArticleBloc = resolve(Blocs.helpArticle);
  private readonly helpArticleCategoryBloc = resolve(Blocs.helpArticleCategory);

  constructor(private readonly categoryId: ArticleCategoryId) {
    super();
  }

  loading = new LoadingState();

  readonly categories$ = this.helpArticleCategoryBloc.helpArticleCategories$.pipe(
    map(categories => {
      return R.filter(categories, c => c.parent == this.categoryId);
    }),
  );

  readonly articles$ = this.helpArticleBloc.helpArticles$;

  onInit() {
    return forkJoin(this.helpArticleCategoryBloc.fetchHelpArticleCategories(), this.helpArticleBloc.fetchHelpArticles(this.categoryId)).pipe(
      this.loading.run(),
    );
  }

  createHelpArticle = this.helpArticleBloc.createHelpArticle;
  deleteHelpArticle = this.helpArticleBloc.deleteHelpArticle;
  deleteCategory = this.helpArticleCategoryBloc.deleteHelpArticleCategory;
}
